module.exports = __webpack_public_path__ + "img/test1.009c1efa.svg";